import { Feature, FeatureCollection, MultiPolygon } from 'geojson';

import type { FieldFeature, FieldsFeatureCollection } from './fields';

export type FieldFeatureWithGeometry = FieldFeature & { geometry: MultiPolygon };

export type PlotFeature = FieldsFeatureCollection['features'][number];

export type PlotFeatureWithGeometry = PlotFeature & { geometry: MultiPolygon };

export function hasFieldGeometry(
  feature: FieldFeature,
): feature is FieldFeatureWithGeometry {
  return feature.geometry != null;
}

export function hasPlotGeometry(
  feature: PlotFeature,
): feature is PlotFeatureWithGeometry {
  return feature.geometry != null;
}

export function asGeoJsonFeature(
  feature: FieldFeatureWithGeometry | PlotFeatureWithGeometry,
): Feature {
  return feature as Feature;
}

export function asFieldsFeatureCollection(
  collection: FeatureCollection,
): FieldsFeatureCollection {
  return collection as FieldsFeatureCollection;
}

export function asFieldsFeatureCollectionFromFeatures(
  features: PlotFeatureWithGeometry[],
): FieldsFeatureCollection {
  return {
    type: 'FeatureCollection',
    features,
  } as FieldsFeatureCollection;
}
